import { Component, OnInit } from "@angular/core";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SysAdminService } from "../services/sysadmin.service";

@Component({
	selector: "app-user-group-administration",
	templateUrl: "./user-group-administration.component.html",
	styleUrls: ["./user-group-administration.component.css"],
})
export class UserGroupAdministrationComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private userService: UserService,
		private schoolService: SchoolService,
		private sysAdminService: SysAdminService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadPreference();

		// this.loadSchoolist();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////
	// Data
	////////////////////////////////////

	subscription: any;

	user: any;
	AllowDistrictGroups: boolean = false;

	SchoolID: any;
	lstSchool: any = [];

	SelectedUserGroup: any;

	////////////////////////////////////

	////////////////////////////////////
	// Load Data
	////////////////////////////////////
	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.SchoolID = this.lstSchool[0].SchoolID;
			},
			(error) => {}
		);
	}

	private loadPreference() {
		var result = this.sysAdminService.UserGroupPreferencesSelect();
		result.subscribe(
			(response: any) => {
				this.AllowDistrictGroups = response.AllowDistrictGroups;
			},
			(error) => {}
		);
	}

	////////////////////////////////////

	////////////////////////////////////
	// Buttons
	////////////////////////////////////

	////////////////////////////////////

	////////////////////////////////////
	// Events
	////////////////////////////////////
	onSchoolChange(val) {
		this.SchoolID = val;
	}
	onGroupSelected(val) {
		this.SelectedUserGroup = val;
	}
	////////////////////////////////////
}
